export default {
    RESPONSE_CODE_LIST: {
        SUCCESS: 200,
        TOKEN_INVALID: 401
    },
    ECONOMIC_CONDITION_LIST: [
        { name: '建档立卡贫困户', value: 1 },
        { name: '低保户', value: 2 },
        { name: '残疾人', value: 3 },
        { name: '五保户', value: 4 },
        { name: '一般户', value: 5 }
    ],
    RELATIONSHIP_LIST_WITH_HOLDER: [
        { name: '丈夫', value: 1 },
        { name: '妻子', value: 2 },
        { name: '儿子', value: 3 },
        { name: '女儿', value: 4 },
        { name: '孙子', value: 5 },
        { name: '孙女', value: 15 },
        { name: '外孙子', value: 6 },
        { name: '外孙女', value: 7 },
        { name: '父亲', value: 8 },
        { name: '母亲', value: 9 },
        { name: '爷爷', value: 10 },
        { name: '奶奶', value: 11 },
        { name: '外公', value: 12 },
        { name: '外婆', value: 13 },
        { name: '其他', value: 14 }
    ],
    BUILD_TIME_LIST: [{
        name: '1949年及以前'
    },
    {
        name: '1950-1959'
    },
    {
        name: '1960-1969'
    },
    {
        name: '1970-1979'
    },
    {
        name: '1980-1989'
    },
    {
        name: '1990-1999'
    },
    {
        name: '2000-2009'
    },
    {
        name: '2010-2019'
    }
    ],
    STRUCTURE_TYPE_LIST: [{
        name: '木结构',
        value: 1,
    },
    {
        name: '砖混结构',
        value: 2,
    },
    {
        name: '石结构',
        value: 3,
    },
    {
        name: '砖木结构',
        value: 4,
    },
    {
        name: '土坯结构',
        value: 5,
    },
    {
        name: '茅草房',
        value: 6,
    },
    {
        name: '其它',
        value: 7,
    }
    ],
    REMOULD_LEVEL_LIST: [{
        name: "一级",
        value: 1,
    },
    {
        name: "二级",
        value: 2,
    },
    {
        name: "三级",
        value: 3
    }
    ],
    REMOULD_TYPE_LIST: [{
        name: '易地扶贫搬迁户',
        value: 1
    },
    {
        name: '生态水库移民',
        value: 2
    },
    {
        name: '养老院（福利院、敬老院等）居住',
        value: 3
    },
    {
        name: '与有安全住房子女共同生活',
        value: 4
    },
    {
        name: '已购其他安全住房',
        value: 5
    },
    {
        name: '其他（户主已死亡等情况）',
        value: 6
    },
    {
        name: '无房户',
        value: 7
    }
    ],
    YES_NO_LIST: [{
        name: '否',
        value: 0
    },
    {
        name: '是',
        value: 1
    }
    ],
    SAFETY_ASSESS_LIST: [{
        name: 'A',
        value: 1
    },
    {
        name: 'B',
        value: 2
    }
    ],
    YEAR_LIST: [
        { value: "2005" }, { value: "2006" }, { value: "2007" }, { value: "2008" }, { value: "2009" },
        { value: "2010" }, { value: "2011" }, { value: "2012" }, { value: "2013" }, { value: "2014" },
        { value: "2015" }, { value: "2016" }, { value: "2017" }, { value: "2018" }, { value: "2019" }
    ],
    PROPERTY_REGISTRATION_LIST: [{
        name: '未办理',
        value: 0
    },
    {
        name: '已办理',
        value: 1
    }
    ],
    GARBAGE_TYPE_LIST: [
        { name: "亲子", value: 1 },
        { name: "团建", value: 2 },
        { name: "户外", value: 3 },
        { name: "度假", value: 4 }
    ],
    VILLAGE_TYPE_LIST: [
        { name: "行政村", value: 5 },
        { name: "自然村", value: 6 }
    ],
    CATEGORY: [
        {
            name: '农村住房',
            value: 'rural_housing',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/village_icon.png',
            sub: [
                {
                    name: '自然灾害导致房屋损坏',
                    value: 'natural_disaster'
                },
                {
                    name: '房屋自然损坏',
                    value: 'house_damage'
                },
                {
                    name: '其他',
                    value: 'rural_housing_other'
                }
            ]
        },
        {
            name: '垃圾治理',
            value: 'garbage_management',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/trash_icon.png',
            sub: [
                {
                    name: '垃圾乱堆乱倒',
                    value: 'rubbish'
                },
                {
                    name: '垃圾箱满无人清理',
                    value: 'nobody_clean'
                },
                {
                    name: '垃圾箱缺失、损坏',
                    value: 'damage'
                },
                {
                    name: '其他',
                    value: 'garbage_management_other'
                }
            ]
        },
        {
            name: '厕所治理',
            value: 'toilet_governance',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/wc_icon.png',
            sub: [
                {
                    name: '户厕非卫生厕所',
                    value: 'hygienic_toilets'
                },
                {
                    name: '公厕脏、乱、差',
                    value: 'messy_poor'
                },
                {
                    name: '公厕设施损坏',
                    value: 'damage'
                },
                {
                    name: '公厕不可正常使用',
                    value: 'not_ormal_use'
                },
                {
                    name: '其他',
                    value: 'toilet_governance_other'
                }
            ]
        },
        {
            name: '污水治理',
            value: 'sewage',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/water_icon.png',
            sub: [
                {
                    name: '污水乱泼乱倒',
                    value: 'messy'
                },
                {
                    name: '工业污水偷排',
                    value: 'steal_row'
                },
                {
                    name: '污水管网破损',
                    value: 'damage'
                },
                {
                    name: '井盖损坏、缺失',
                    value: 'missing'
                },
                {
                    name: '其他',
                    value: 'sewage_other'
                }
            ]
        },
        {
            name: '村庄清洁行动',
            value: 'clean',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/clean_icon.png',
            sub: [
                {
                    name: '粪便暴漏',
                    value: 'exposure'
                },
                {
                    name: '杂物乱堆乱放',
                    value: 'misplace'
                },
                {
                    name: '房前屋后脏乱',
                    value: 'messy'
                },
                {
                    name: '其他',
                    value: 'clean_other'
                }
            ]
        }


    ]
};